import api from '@/services/api';
const ENTITY_ENDPOINT = 'ubicacion';

export class UbicacionService {
  /**
   * Obtiene todos los ubicaciones con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los ubicaciones con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Busca ubicaciones por nombre o criterio
   * @param {string} query - Término de búsqueda
   * @param {Object} additionalParams - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async search(query, additionalParams = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/`, {
      params: {
        Nombre: query,
        ...additionalParams,
      },
    });
  }

  /**
   * Obtiene un ubicacion por su ID
   * @param {string|number} id - ID del ubicacion
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea un nuevo ubicacion
   * @param {Object} ubicacion - Datos del ubicacion a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(ubicacion) {
    return await api.post(`/${ENTITY_ENDPOINT}`, ubicacion);
  }

  /**
   * Actualiza un ubicacion existente
   * @param {string|number} id - ID del ubicacion
   * @param {Object} ubicacion - Datos del ubicacion a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, ubicacion) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, ubicacion);
  }

  /**
   * Elimina un ubicacion
   * @param {string|number} id - ID del ubicacion
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default UbicacionService;
